import { customAlphabet } from 'nanoid';
export const nanoid = customAlphabet('ABCDEF1234567890', 20);
